import * as React from 'react';
import { Text, Icon } from '@fluentui/react';
import { useTranslation, Trans } from 'react-i18next';

export const NoDataFoundedForSelectedFilters = (props: { text: string }) => {
    const { t, i18n } = useTranslation();

    return (
        <div className="empty-state-panel">
            <Icon iconName="AddGroup" className="empty-state-panel-icon"></Icon>
            <Text variant="medium" className="empty-state-panel-text">
                {t('No hay horas registradas en ') + props.text + t(' para los filtros seleccionados')}
            </Text>
        </div>
    );
};
